import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./InputStyles.scss";
import { FaRegEye, FaRegEyeSlash, FaPaste } from "react-icons/fa";
import { MdClear } from "react-icons/md";

const inputRef = React.createRef();

const Input = ({
  error,
  tabIndex = 0,
  type,
  className = "",
  label,
  disabled,
  size = "",
  setFocus = 0,
  isrequired = false,
  isvalnum = "",
  min = "",
  extraStyle,
  icon,
  showPasteIcon = false,
  handlePaste,
  showClearIcon,
  handleClear,
  isSearchInput = false,
  ...props
}) => {
  useEffect(() => {
    if (setFocus) {
      inputRef.current.focus();
    }
  }, [setFocus]);

  let [newType, setNewType] = useState(type === "password" ? "password" : type);

  const changeType = () => {
    if (newType === "password") {
      setNewType("text");
    } else {
      setNewType("password");
    }
  };

  const handleKeyPress = (e) => {
    if (isvalnum === "isNum") {
      let charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        e.preventDefault();
      }
    }
    if (isvalnum === "alphanumeric") {
      // var , i, len;
      let code = e.which ? e.which : e.keyCode;
      // for (i = 0, len = str.length; i < len; i++) {
      //   code = str.charCodeAt(i);
      // }
      if (
        !(code > 47 && code < 58) && // numeric (0-9)
        !(code > 64 && code < 91) && // upper alpha (A-Z)
        !(code > 96 && code < 123)
      ) {
        // lower alpha (a-z)
        e.preventDefault();
      }
    }
  };

  //--------------onFocus set cursor end of the text if text is available
  const [initialFocus, setInitialFocus] = useState(true);

  function moveCursorToEnd(e) {
    const input = e.target;
    const length = input.value.length;
    // On initial focus, move the cursor to the end
    if (initialFocus) {
      input.focus(); // Focus on the input
      input.setSelectionRange(length, length); // Set the cursor to the end
      input.scrollLeft = input.scrollWidth; // Scroll to the end of the text
    }
  }

  const handleClick = (e) => {
    moveCursorToEnd(e); // Move cursor to the end on first focus
    setInitialFocus(false); // Any click should now allow normal cursor behavior
  };

  const handleBlur = () => {
    setInitialFocus(true); // Reset initialFocus to true when the input loses focus
  };

  return (
    <div
      className={`input-wrapper ${
        isSearchInput && "extraStylesControlWrapper"
      }`}
    >
      <span className={label ? `input-label text-muted` : "d-none"}>
        {label} {isrequired && <span /*className="text-danger"*/>*</span>}
      </span>
      <span className={icon ? `icon_wrapper` : "d-none"}>{icon}</span>
      <input
        icon={icon}
        ref={inputRef}
        type={newType}
        tabIndex={tabIndex}
        disabled={disabled}
        onKeyPress={handleKeyPress}
        onClick={handleClick} // Set cursor to clicked position after first click
        onBlur={handleBlur} // Reset initial focus state when input loses focus
        min={min}
        className={`
          input input_extra
          ${extraStyle}
          ${error && !disabled ? "input_error" : ""}
          ${disabled ? "disabled" : ""}
          ${size}
          ${showClearIcon && "with-clear-icon"}
           ${type === "password" && "password-icon-padding"}
          `}
        {...props}
      />

      {type === "password" && (
        <span
          onMouseDown={(e) => e.preventDefault()}
          className="isShowWrapper"
          onClick={changeType}
        >
          {newType === "password" ? (
            <FaRegEye className="isShowIcon" />
          ) : (
            <FaRegEyeSlash className="isShowIcon" />
          )}
        </span>
      )}

      {showPasteIcon && (
        <span onMouseDown={(e) => e.preventDefault()} className="isShowWrapper">
          <FaPaste className="isShowIcon" onClick={() => handlePaste()} />
        </span>
      )}

      {showClearIcon && (
        <span onMouseDown={(e) => e.preventDefault()} className="isShowWrapper">
          <MdClear className="isShowIcon" onClick={() => handleClear()} />
        </span>
      )}

      <div className={`error`}>{error && !disabled ? error : ""}</div>
    </div>
  );
};

Input.propTypes = {
  type: PropTypes.string,
  error: PropTypes.string,
  className: PropTypes.string,
  tabIndex: PropTypes.number,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.string,
};

Input.defaultProps = {
  type: "text",
};

export default Input;
